export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  categorySlug: string;
  image: string;
  author: string;
  publishDate: string;
  readCount: number;
  hotTag?: string;
  tags: string[];
  isHot?: boolean;
  isTop?: boolean;
}

export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  image: string;
  articleCount: number;
}

export interface HotTopic {
  id: string;
  title: string;
  heat: number;
  link: string;
}

export const categories: Category[] = [
  {
    id: "1",
    name: "今日大瓜",
    slug: "today-hot",
    description: "每日最热最劲爆的吃瓜爆料，全网焦点一网打尽",
    image: "https://readdy.ai/api/search-image?query=Dark%20mysterious%20gossip%20news%20atmosphere%2C%20silhouette%20crowd%20whispering%2C%20red%20spotlight%20dramatic%20lighting%2C%20minimalist%20dark%20background%2C%20editorial%20photography%20style&width=400&height=400&seq=cat-today-hot&orientation=squarish",
    articleCount: 128,
  },
  {
    id: "2",
    name: "明星八卦",
    slug: "celebrity",
    description: "娱乐圈明星绯闻、恋情、分手、隐婚等独家内幕爆料",
    image: "https://readdy.ai/api/search-image?query=Hollywood%20paparazzi%20style%20celebrity%20spotlight%20on%20dark%20red%20carpet%2C%20camera%20flashes%20dramatic%20lighting%2C%20mysterious%20silhouette%20figure%2C%20dark%20atmospheric%20background%2C%20editorial%20photography&width=400&height=400&seq=cat-celebrity&orientation=squarish",
    articleCount: 256,
  },
  {
    id: "3",
    name: "网红黑料",
    slug: "influencer",
    description: "网红主播翻车现场、黑历史曝光、人设崩塌实录",
    image: "https://readdy.ai/api/search-image?query=Social%20media%20influencer%20dark%20aesthetic%2C%20broken%20phone%20screen%20scattered%20social%20icons%2C%20red%20dramatic%20lighting%2C%20dark%20background%2C%20digital%20glitch%20art%20style&width=400&height=400&seq=cat-influencer&orientation=squarish",
    articleCount: 189,
  },
  {
    id: "4",
    name: "影视娱乐",
    slug: "entertainment",
    description: "影视剧幕后花絮、拍摄秘闻、剧组八卦与明星互动",
    image: "https://readdy.ai/api/search-image?query=Movie%20theater%20stage%20curtain%20dramatic%20red%20spotlight%2C%20film%20reels%20scattered%20on%20dark%20floor%2C%20cinematic%20atmosphere%2C%20moody%20dark%20background%2C%20editorial%20photography&width=400&height=400&seq=cat-entertainment&orientation=squarish",
    articleCount: 143,
  },
  {
    id: "5",
    name: "吃瓜现场",
    slug: "live-gossip",
    description: "实时爆料现场直播、网友投稿爆料、突发吃瓜事件追踪",
    image: "https://readdy.ai/api/search-image?query=Breaking%20news%20scene%20dark%20dramatic%2C%20microphone%20and%20spotlight%20on%20empty%20podium%2C%20red%20emergency%20lights%2C%20dark%20mysterious%20atmosphere%2C%20documentary%20photography%20style&width=400&height=400&seq=cat-live-gossip&orientation=squarish",
    articleCount: 97,
  },
  {
    id: "6",
    name: "富豪秘闻",
    slug: "rich-gossip",
    description: "富豪圈子秘闻、豪门恩怨、商界大佬不为人知的秘密",
    image: "https://readdy.ai/api/search-image?query=Luxury%20dark%20mysterious%20atmosphere%2C%20expensive%20watch%20and%20cufflinks%20on%20black%20marble%20surface%2C%20dim%20golden%20ambient%20lighting%2C%20wealth%20and%20secrets%20mood%2C%20editorial%20product%20photography&width=400&height=400&seq=cat-rich-gossip&orientation=squarish",
    articleCount: 76,
  },
];

export const articles: Article[] = [
  {
    id: "1",
    title: "顶流男星被曝隐婚生子！妻子竟是圈内知名经纪人",
    summary: "据知情人士爆料，某当红顶流男星已秘密结婚三年，并育有一子。女方身份曝光后网友震惊，竟是陪伴其多年的执行经纪人...",
    content: `<p>据知情人士向本台独家爆料，某当红顶流男星L某已秘密结婚长达三年之久，并育有一子，消息一出全网哗然。</p>
<p>爆料者称，L某与妻子早在2021年就已领证结婚，女方正是陪伴其出道至今的执行经纪人W女士。两人日常以工作关系示人，实则已是夫妻关系。知情人士还透露，L某在北京某高档小区购置了价值千万的豪宅，正是两人实际居住地。</p>
<p>该爆料一经发布，相关话题迅速登上微博热搜榜首。网友纷纷表示"太震惊了"、"原来朝夕相处的人才是真爱"。截至目前，L某工作室尚未对此事作出回应。</p>
<p>值得关注的是，L某此前在公开场合多次表示自己"单身"、"专注事业"，如今看来全是人设包装。吃瓜网51将持续追踪此事后续发展。</p>`,
    category: "明星八卦",
    categorySlug: "celebrity",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20celebrity%20paparazzi%20scene%2C%20dark%20mysterious%20figure%20in%20hoodie%20walking%20through%20city%20night%20with%20camera%20flashes%2C%20red%20dramatic%20street%20lighting%2C%20cinematic%20atmosphere%2C%20editorial%20photography%20style&width=800&height=500&seq=article-01&orientation=landscape",
    author: "吃瓜小编",
    publishDate: "2026-07-02",
    readCount: 128456,
    hotTag: "爆",
    tags: ["顶流男星", "隐婚", "经纪人", "人设崩塌"],
    isHot: true,
    isTop: true,
  },
  {
    id: "2",
    title: "千万粉丝女网红直播翻车！滤镜掉了真面目曝光",
    summary: "某平台千万级粉丝女网红在昨日直播中意外关闭美颜滤镜，真实颜值与平日视频差距巨大，直播间瞬间掉粉十万...",
    content: `<p>昨日晚间，某短视频平台千万级粉丝女网红"糖心小姐"在进行日常直播带货时，因操作失误意外关闭了美颜滤镜和瘦脸特效，其真实容貌瞬间暴露在数十万在线观众面前。</p>
<p>据目击者描述，关闭滤镜后的"糖心小姐"与平日视频中展示的清纯甜美形象判若两人，面部轮廓、肤色、五官均有明显差异。直播间弹幕瞬间被"？？？""这是同一个人？""退粉了"刷屏。</p>
<p>数据显示，在短短半小时内，该网红粉丝数从1023万暴跌至1012万，掉粉超过十万。更有网友扒出其早期未修图照片，指出其曾多次整容。</p>
<p>事件发酵后，"糖心小姐"发布道歉声明称自己"状态不好"，但网友并不买账，质疑其长期以来利用重度滤镜欺骗粉丝。</p>`,
    category: "网红黑料",
    categorySlug: "influencer",
    image: "https://readdy.ai/api/search-image?query=Social%20media%20livestream%20drama%20dark%20aesthetic%2C%20broken%20smartphone%20screen%20with%20live%20broadcast%20icons%20shattered%2C%20red%20dramatic%20warning%20lights%2C%20dark%20background%2C%20editorial%20photography%20style&width=800&height=500&seq=article-02&orientation=landscape",
    author: "爆料君",
    publishDate: "2026-07-01",
    readCount: 98632,
    hotTag: "热",
    tags: ["网红翻车", "美颜滤镜", "直播事故", "掉粉"],
    isHot: true,
  },
  {
    id: "3",
    title: "某上市公司CEO婚外恋曝光！小三竟是公司女高管",
    summary: "商界大地震！知名上市公司CEO被妻子实名举报出轨，出轨对象竟是自己公司的女高管。妻子发文晒证据，全网吃瓜...",
    content: `<p>昨日凌晨，某知名上市公司CEO的妻子在个人社交平台发布长文，实名举报丈夫出轨，并晒出大量聊天记录和照片证据，引爆全网。</p>
<p>据妻子爆料，丈夫与小三的地下恋情已持续两年之久，而小三的身份令人大跌眼镜——竟是丈夫所在公司的市场部女总监。两人不仅在工作时间频繁出入酒店，还利用公司公款报销约会开销。</p>
<p>妻子文中写道："我以为他加班是真的在忙事业，没想到是在忙别的女人。"短短数小时，该文转发量突破50万。</p>
<p>受该事件影响，该公司股价今日开盘即大跌8%，市值蒸发近20亿。公司董事会已宣布成立专项调查组，CEO目前处于停职状态。</p>`,
    category: "富豪秘闻",
    categorySlug: "rich-gossip",
    image: "https://readdy.ai/api/search-image?query=Corporate%20scandal%20dark%20dramatic%20atmosphere%2C%20luxury%20executive%20office%20desk%20at%20night%20with%20scattered%20documents%20and%20phone%20messages%2C%20dark%20blue%20red%20dramatic%20lighting%2C%20mysterious%20corporate%20betrayal%20mood%2C%20editorial%20photography&width=800&height=500&seq=article-03&orientation=landscape",
    author: "财经吃瓜组",
    publishDate: "2026-07-01",
    readCount: 87654,
    hotTag: "爆",
    tags: ["CEO出轨", "上市公司", "婚外恋", "实名举报"],
    isHot: true,
  },
  {
    id: "4",
    title: "年度重磅大瓜！当红小花与导演不正当关系实锤流出",
    summary: "某95后当红小花被曝与知名导演存在不正当关系，聊天记录、开房记录全被黑客曝光。多个代言品牌已宣布解约...",
    content: `<p>今日上午，某95后当红小花Z某与知名导演C某的不正当关系遭黑客曝光，大量聊天记录、酒店开房记录、转账凭证在网络上疯传。</p>
<p>据曝光的资料显示，两人自2024年起维持不正当关系长达一年多。导演C某多次以"试镜""聊剧本"为由约Z某到酒店房间，聊天记录内容露骨，不堪入目。</p>
<p>更劲爆的是，Z某能在短短两年内从十八线跃升为一线小花，主演三部大制作，据爆料均与导演C某的"特殊关照"有关。</p>
<p>事件曝光后，Z某的五个品牌代言已宣布终止合作，损失代言费超5000万。导演C某则被其妻子起诉离婚，要求孩子抚养权和财产分割。</p>`,
    category: "影视娱乐",
    categorySlug: "entertainment",
    image: "https://readdy.ai/api/search-image?query=Film%20set%20behind%20the%20scenes%20scandal%20dark%20atmosphere%2C%20empty%20directors%20chair%20and%20clapperboard%20on%20dark%20stage%20with%20single%20red%20spotlight%2C%20mysterious%20cinematic%20mood%2C%20dramatic%20shadows%2C%20editorial%20photography%20style&width=800&height=500&seq=article-04&orientation=landscape",
    author: "娱乐圈探长",
    publishDate: "2026-06-30",
    readCount: 156789,
    hotTag: "爆",
    tags: ["95后小花", "导演丑闻", "不正当关系", "黑客曝光"],
    isHot: true,
    isTop: true,
  },
  {
    id: "5",
    title: "富二代网红飙车撞人！事后还发视频挑衅受害者家属",
    summary: "某富二代网红深夜飙车撞上行人致其重伤，不仅不道歉反而在社交平台发视频炫耀，激怒全网网友...",
    content: `<p>6月28日凌晨，某知名富二代网红"少爷K"驾驶价值500万的超跑在某市繁华路段飙车，因车速过快撞上一名正在过马路的行人，致其重伤送医。</p>
<p>令人愤怒的是，事故发生后，"少爷K"非但没有第一时间施救，反而在车内与朋友嬉笑，随后扬长而去。更令人发指的是，其在事发后数小时发布了一条视频，配文"刺激的一晚"，视频中能清晰看到车辆受损情况。</p>
<p>受害者家属在看到视频后怒不可遏，将视频证据提交给警方。据医院消息，受害者双腿骨折，目前仍在重症监护室接受治疗。</p>
<p>在舆论压力下，"少爷K"已删除相关视频并发布道歉声明，但网友并不买账，纷纷呼吁严惩。目前该案已由交警部门立案侦查。</p>`,
    category: "吃瓜现场",
    categorySlug: "live-gossip",
    image: "https://readdy.ai/api/search-image?query=Sports%20car%20accident%20scene%20dramatic%20dark%20atmosphere%2C%20damaged%20luxury%20supercar%20on%20wet%20night%20street%20with%20police%20tape%20and%20emergency%20lights%2C%20red%20dramatic%20lighting%2C%20mysterious%20mood%2C%20cinematic%20photography%20style&width=800&height=500&seq=article-05&orientation=landscape",
    author: "社会吃瓜组",
    publishDate: "2026-06-29",
    readCount: 112345,
    hotTag: "热",
    tags: ["富二代", "飙车", "交通肇事", "网红作恶"],
    isHot: true,
  },
  {
    id: "6",
    title: "某选秀节目内幕曝光！冠军早已内定，选手全靠花钱买",
    summary: "热门选秀节目《青春有你X》被前工作人员爆料存在严重黑幕，冠军人选比赛前就已确定，选手晋级需要缴纳高额费用...",
    content: `<p>昨日，一位自称《青春有你X》前工作人员的网友在社交平台发布万字长文，曝光该选秀节目存在严重黑幕，引发轩然大波。</p>
<p>据爆料，节目的最终出道位和排名在比赛开始前就已由投资方和平台方协商确定，选手的排名主要取决于其背后的经纪公司愿意出多少"赞助费"。爆料者称，进入决赛圈的12名选手中，有8名是通过缴纳高额费用保送的。</p>
<p>爆料还指出，节目的投票数据存在严重注水，所谓的"观众投票"只是摆设，实际结果完全由后台操控。某选手在总决赛当晚的票数在短短10分钟内暴涨200万，明显不合常理。</p>
<p>对此，《青春有你X》节目组发布声明称爆料"纯属造谣"，已委托律师处理。但网友扒出爆料者确实曾在节目组工作，且晒出的工作证经核实为真。</p>`,
    category: "影视娱乐",
    categorySlug: "entertainment",
    image: "https://readdy.ai/api/search-image?query=Talent%20show%20stage%20behind%20scenes%20dark%20atmosphere%2C%20empty%20spotlight%20stage%20with%20voting%20numbers%20floating%20in%20dark%20air%2C%20red%20dramatic%20theater%20lighting%2C%20mysterious%20show%20business%20corruption%20mood%2C%20editorial%20photography&width=800&height=500&seq=article-06&orientation=landscape",
    author: "综艺爆料王",
    publishDate: "2026-06-28",
    readCount: 76543,
    hotTag: "热",
    tags: ["选秀黑幕", "内定冠军", "综艺造假", "投票注水"],
  },
  {
    id: "7",
    title: "知名男星被曝欠赌债千万！多名债主上门讨债视频流出",
    summary: "某实力派男演员被曝沉迷赌博欠下巨额债务，多名债主上门讨债视频曝光。其妻子已带着孩子搬离住所...",
    content: `<p>近日，某实力派男演员H某被曝沉迷赌博，欠下高达3000万的巨额赌债，多名债主上门讨债的视频在网络上流传。</p>
<p>据流出的视频显示，三名男子在某高档住宅小区楼下堵住H某，情绪激动地要求其"还钱"。H某则低声下气地请求"再宽限几天"。视频中还有目击者称，这已不是第一批上门讨债的人。</p>
<p>另有知情人士透露，H某的妻子已带着孩子搬离两人共同住所，回娘家居住。H某近年来接戏数量锐减，可能与其赌博欠债有关。</p>
<p>H某此前一直以"好丈夫""好爸爸"形象示人，曾带妻子孩子参加多档亲子综艺。如今人设崩塌，网友感叹"表面越完美，背后越不堪"。</p>`,
    category: "明星八卦",
    categorySlug: "celebrity",
    image: "https://readdy.ai/api/search-image?query=Dark%20moody%20debt%20collection%20scene%2C%20shadowy%20figures%20confronting%20man%20in%20dimly%20lit%20alley%20with%20neon%20red%20signs%2C%20cinematic%20noir%20atmosphere%2C%20dramatic%20tension%20mood%2C%20editorial%20photography%20style&width=800&height=500&seq=article-07&orientation=landscape",
    author: "八卦追踪队",
    publishDate: "2026-06-27",
    readCount: 65432,
    tags: ["赌博欠债", "实力派演员", "债主上门", "人设崩塌"],
  },
  {
    id: "8",
    title: "名媛培训班骗局曝光！交50万学费只为钓金龟婿",
    summary: '高端名媛培训班被前学员实名举报，所谓的"名媛课程"全是骗局，花50万学到的只是如何P图和装腔作势...',
    content: `<p>近日，一家名为"皇家名媛学院"的高端培训班被前学员实名举报，所谓的名媛培训课程被指是一场精心设计的骗局。</p>
<p>举报人张女士称，自己缴纳了50万元学费参加为期三个月的"顶级名媛养成课程"，结果发现课程内容极其离谱：包括"如何识别真名牌包包""如何在米其林餐厅装作经常来""如何在社交软件上包装自己"等。最核心的一节课竟是"如何认识有钱男人"。</p>
<p>张女士还发现，该机构所谓的"成功学员嫁入豪门案例"全是编造的故事，所谓"嫁给富豪的学姐"其实是机构花钱请来的演员。</p>
<p>目前，当地市场监管部门已介入调查，初步查明该机构并无教育培训资质，属于超范围经营。</p>`,
    category: "富豪秘闻",
    categorySlug: "rich-gossip",
    image: "https://readdy.ai/api/search-image?query=Luxury%20lifestyle%20scam%20exposed%20dark%20atmosphere%2C%20expensive%20designer%20handbags%20and%20champagne%20glasses%20on%20black%20table%20with%20cracked%20mirror%20reflection%2C%20red%20dramatic%20lighting%2C%20deception%20and%20luxury%20mood%2C%20editorial%20photography&width=800&height=500&seq=article-08&orientation=landscape",
    author: "社会调查员",
    publishDate: "2026-06-26",
    readCount: 54321,
    tags: ["名媛培训班", "骗局曝光", "50万学费", "嫁入豪门"],
  },
  {
    id: "9",
    title: "今日大瓜！某男星演唱会假唱被现场抓包，观众当场喊退票",
    summary: "某当红男歌手昨晚演唱会现场假唱对口型，因麦克风故障露出破绽，被现场观众当场识破并齐声喊退票...",
    content: `<p>昨晚，某当红男歌手G某在某大型体育馆举办个人演唱会，不料因设备故障意外暴露假唱行为，引发全场观众愤怒。</p>
<p>据现场观众描述，G某在演唱成名曲时，手中的麦克风突然出现故障没有声音，但场馆音响中却依然传出"完美"的歌声。全场观众愣了几秒后，瞬间爆发出嘘声和"假唱""退票"的怒吼。</p>
<p>G某在台上尴尬地停顿了约30秒，随后工作人员送上新麦克风才继续演出。但现场氛围已完全被破坏，后半场观众大量离场。</p>
<p>事后，G某在社交平台发文称"设备故障导致演出中断，向大家道歉"，但并未回应假唱质疑。专业音乐人分析现场视频后确认，该歌手确实存在对口型行为。</p>`,
    category: "今日大瓜",
    categorySlug: "today-hot",
    image: "https://readdy.ai/api/search-image?query=Concert%20stage%20scandal%20dramatic%20dark%20atmosphere%2C%20broken%20microphone%20on%20stage%20floor%20with%20spotlight%20and%20crowd%20silhouettes%20in%20background%2C%20red%20dramatic%20concert%20lighting%2C%20music%20performance%20fraud%20mood%2C%20editorial%20photography&width=800&height=500&seq=article-09&orientation=landscape",
    author: "现场爆料组",
    publishDate: "2026-07-02",
    readCount: 98765,
    hotTag: "爆",
    tags: ["演唱会假唱", "对口型", "观众退票", "设备故障"],
    isHot: true,
  },
  {
    id: "10",
    title: "百万粉美食博主塌房！卖的食品全是三无产品吃坏粉丝",
    summary: "知名美食测评博主被曝推荐的食品均为三无产品，多名粉丝食用后出现不适。其带货佣金率高达50%...",
    content: `<p>拥有300万粉丝的知名美食测评博主"吃货大王"近日被多名粉丝联合举报，其直播带货的食品被指为三无产品，已有多人食用后出现腹泻等不适症状。</p>
<p>据受害者王女士称，她在"吃货大王"直播间购买了推荐的"手工牛肉干"，食用后出现严重腹泻就医。经检查发现，该产品包装上没有生产厂家、生产日期、保质期等任何标识，属于典型的三无产品。</p>
<p>更令人震惊的是，有业内人士爆料"吃货大王"的带货佣金率高达50%，也就是说售价100元的商品，他能抽走50元。为了利益最大化，他不惜推荐质量低劣的商品给粉丝。</p>
<p>目前，已有超过20名受害者联合起来准备起诉该博主。相关电商平台也已下架其推荐的全部食品。</p>`,
    category: "网红黑料",
    categorySlug: "influencer",
    image: "https://readdy.ai/api/search-image?query=Food%20safety%20scandal%20dark%20atmosphere%2C%20unlabeled%20packaged%20food%20products%20scattered%20on%20dark%20table%20with%20warning%20signs%20and%20broken%20smartphone%20showing%20livestream%2C%20red%20dramatic%20lighting%2C%20dangerous%20consumer%20fraud%20mood%2C%20editorial%20photography&width=800&height=500&seq=article-10&orientation=landscape",
    author: "食品安全观察",
    publishDate: "2026-06-25",
    readCount: 67890,
    hotTag: "热",
    tags: ["美食博主塌房", "三无产品", "带货翻车", "粉丝受害"],
  },
  {
    id: "11",
    title: "某女星剧组耍大牌！要求全组人员等她三小时才开工",
    summary: "某当红女星在剧组被爆耍大牌，每天迟到三小时以上，还要求全组200多人等她一人。导演敢怒不敢言...",
    content: `<p>某S姓当红女星在近日拍摄的某古装剧组中被爆严重耍大牌，引发剧组工作人员集体不满。</p>
<p>据剧组工作人员爆料，S女星几乎每天都迟到三小时以上，全组200多名工作人员必须等她到了才能开工。有一天全组从早上6点等到上午10点，S女星才姗姗来迟，且没有任何歉意。</p>
<p>更令人难以接受的是，S女星还要求剧组为其单独准备价值上万元的进口水果作为下午茶，并指定某五星级酒店送餐。如有不合心意，当场摔东西发脾气。</p>
<p>导演对此敢怒不敢言，因为S女星是投资方指定的女一号，得罪不起。剧组工作人员只能在私下吐槽，有人已将现场视频偷偷上传网络。</p>`,
    category: "影视娱乐",
    categorySlug: "entertainment",
    image: "https://readdy.ai/api/search-image?query=Film%20set%20diva%20drama%20dark%20atmosphere%2C%20empty%20directors%20chair%20with%20crows%20nest%20equipment%20and%20crew%20waiting%20silhouettes%20in%20dark%20studio%2C%20red%20dramatic%20lighting%2C%20diva%20celebrity%20attitude%20mood%2C%20editorial%20photography&width=800&height=500&seq=article-11&orientation=landscape",
    author: "剧组知情人士",
    publishDate: "2026-06-24",
    readCount: 87654,
    tags: ["耍大牌", "剧组内幕", "迟到三小时", "女明星"],
  },
  {
    id: "12",
    title: "某男星慈善人设翻车！捐款名单查无此人，全靠P图作秀",
    summary: '一直以"慈善家"形象示人的某男星被网友扒出多次公益活动纯属作秀，捐款名单中根本查不到他的名字...',
    content: `<p>一直以"慈善王子"形象示人的男星B某近日被网友深度扒皮，其多年苦心经营的慈善人设面临全面崩塌。</p>
<p>网友调查发现，B某多次在公开场合宣称自己"捐建了五所希望小学""资助了100名贫困学生"，但在中国青少年发展基金会的公开捐赠名单中，根本查不到任何以B某名义的捐赠记录。</p>
<p>更有网友对比B某发布的公益活动照片，发现所谓的"支教现场"其实是在某影视基地取景拍摄，照片中的"学生"都是群演。所谓的"捐赠仪式"上的支票，疑似后期P图合成。</p>
<p>面对网友的实锤证据，B某至今未作出任何回应。其粉丝后援会则辩称"公益不一定要留名"，但该说法被网友反驳："不留名你发什么通稿？"</p>`,
    category: "今日大瓜",
    categorySlug: "today-hot",
    image: "https://readdy.ai/api/search-image?query=Charity%20fraud%20exposed%20dark%20atmosphere%2C%20fake%20donation%20check%20and%20philanthropy%20certificates%20scattered%20on%20dark%20desk%20with%20magnifying%20glass%20revealing%20photoshop%20layers%2C%20red%20dramatic%20lighting%2C%20deception%20and%20fake%20kindness%20mood%2C%20editorial%20photography&width=800&height=500&seq=article-12&orientation=landscape",
    author: "真相调查局",
    publishDate: "2026-06-23",
    readCount: 112345,
    hotTag: "爆",
    tags: ["慈善人设", "假捐款", "P图作秀", "人设翻车"],
    isHot: true,
  },
];

export const hotTopics: HotTopic[] = [
  { id: "1", title: "顶流男星隐婚生子", heat: 985000, link: "/article/1" },
  { id: "2", title: "千万网红滤镜翻车", heat: 876000, link: "/article/2" },
  { id: "3", title: "CEO婚外恋曝光", heat: 765000, link: "/article/3" },
  { id: "4", title: "小花导演不正当关系", heat: 654000, link: "/article/4" },
  { id: "5", title: "富二代飙车撞人", heat: 543000, link: "/article/5" },
  { id: "6", title: "选秀节目内定冠军", heat: 432000, link: "/article/6" },
  { id: "7", title: "男星欠赌债千万", heat: 398000, link: "/article/7" },
  { id: "8", title: "名媛培训班骗局", heat: 345000, link: "/article/8" },
  { id: "9", title: "演唱会假唱被抓", heat: 321000, link: "/article/9" },
  { id: "10", title: "美食博主三无产品", heat: 287000, link: "/article/10" },
];

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((a) => a.id === id);
};

export const getArticlesByCategory = (slug: string): Article[] => {
  return articles.filter((a) => a.categorySlug === slug);
};

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find((c) => c.slug === slug);
};

export const getHotArticles = (limit = 6): Article[] => {
  return articles.filter((a) => a.isHot).slice(0, limit);
};

export const getTopArticles = (limit = 2): Article[] => {
  return articles.filter((a) => a.isTop).slice(0, limit);
};

export const getRelatedArticles = (
  currentId: string,
  categorySlug: string,
  limit = 4
): Article[] => {
  return articles
    .filter((a) => a.id !== currentId && a.categorySlug === categorySlug)
    .slice(0, limit);
};